const objects = require('medisoft.conectordatos.clientjs').objects

const production = new objects.Connector('https', '://', 'oauthservice.medisoftcolombia.com', 'api', 'authservice.medisoftcolombia.com', '443', false)
// const development = new objects.Connector('http', '://', 'localhost', 'api', 'localhost', '50632', true) // Windows sin certificado
// const development = new objects.Connector('https', '://', 'localhost', 'api', 'localhost', '44351', true) // Windows con certificado
// const development = new objects.Connector('https', '://', 'localhost', 'api', 'localhost', '5001', true) // Linux
const development = new objects.Connector('https', '://', 'oauthservice.medisoftcolombia.com', 'api', 'authservice.medisoftcolombia.com', '8080', false)

export default {
  production,
  development
}
